module.exports = __webpack_public_path__ + "static/media/google-play.9d7d3aa4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/App/components/imgs/google-play.svg
// module id = 807
// module chunks = 0